// @flow
export const FOODMODES_FILTER_CLEAR = 'reports/FOODMODES_FILTER_CLEAR';
export const FOODMODES_FILTER_DELETE = 'reports/FOODMODES_FILTER_DELETE';
export const FOODMODES_FILTER_SET = 'reports/FOODMODES_FILTER_SET';
export const FOODMODES_FILTER_UPDATE = 'reports/FOODMODES_FILTER_UPDATE';
